<template>
	<div>
		<a-menu
			mode="inline"
			:open-keys="openKeys"
			:selectedKeys="selectedKeys"
			theme="dark"
			@openChange="onOpenChange"
			:default-selected-keys="['sub3']"
		>
			<a-sub-menu key="sub1">
				<span slot="title">
					<a-icon type="mail" />
					<span>{{ $t('sidemenu.businessManagement') }}</span></span
				>
				<a-menu-item
					key="1"
					@click="changeMenu('/business-dispatch', '1')"
				>
				{{ $t('sidemenu.businessScheduling') }}
				</a-menu-item>
			</a-sub-menu>

			<a-sub-menu key="sub3">
				<span slot="title">
					<a-icon type="pie-chart" />
					<span>{{ $t('sidemenu.basicData') }}</span>
				</span>
				<a-menu-item key="2" @click="changeMenu('/customer-list', '2')">
					<span>{{ $t('sidemenu.customerManagement') }}</span>
				</a-menu-item>
				<a-menu-item key="3" @click="changeMenu('/truck-list', '3')">
					<span>{{ $t('sidemenu.vehicleManagement') }}</span>
				</a-menu-item>
				<a-menu-item key="4" @click="changeMenu('/driver-list', '4')">
					{{ $t('sidemenu.driverManagement') }}
				</a-menu-item>
				<a-menu-item key="5" @click="changeMenu('/location-list', '5')">
					{{ $t('sidemenu.factoryManagement') }}
				</a-menu-item>
				<a-menu-item key="6" @click="changeMenu('/user-list', '6')">
					{{ $t('sidemenu.userManagement') }}
				</a-menu-item>
			</a-sub-menu>

			<a-sub-menu v-if="userInfo.country === 'CN'" key="sub2">
				<span slot="title">
					<a-icon type="account-book" />
					<span slot="title">{{ $t('sidemenu.financialManagement') }}</span>
				</span>
				<a-menu-item key="7" @click="changeMenu('/receivable-list', '7')">
					{{ $t('sidemenu.receivableDetails') }}
				</a-menu-item>
				<a-menu-item key="8" @click="changeMenu('/index/bills-receivable', '8')">
					{{ $t('sidemenu.billsReceivable') }}
				</a-menu-item>
			</a-sub-menu>
		</a-menu>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
	name: "sidemenu",
	data() {
		return {
			rootSubmenuKeys: ["sub1", "sub2", "sub3"],
			openKeys: [],
			selectedKeys: [],
			resources: [],
		};
	},
	computed: {
		...mapGetters(['userInfo'])
	},
	watch: {
		openKeys: {
			handler() {
				let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
				if (!userInfo.keys) {
					userInfo.keys = {};
				}
				userInfo.keys.openKeys = this.openKeys;
				window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
				console.log(JSON.parse(window.localStorage.getItem("userInfo")));
			},
			deep: true,
		},
		selectedKeys: {
			handler() {
				let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
				if (!userInfo.keys) {
					userInfo.keys = {};
				}
				userInfo.keys.selectedKeys = this.selectedKeys;
				window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
				console.log(JSON.parse(window.localStorage.getItem("userInfo")));
			},
			deep: true,
		},
	},
	created() {
		let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
		if (userInfo.keys) {
			console.log(userInfo.keys);
			this.openKeys = userInfo.keys.openKeys;
			this.selectedKeys = userInfo.keys.selectedKeys;
		} else {
			this.openKeys = ["sub1", "sub2", "sub3"];
			this.selectedKeys = ["1"];
		}
	},
	methods: {
		onOpenChange(openKeys) {
			console.log("openKeys ==== ", openKeys);
			this.openKeys = openKeys;
		},
		//路由内容切换
		// changeMenu(route, index) {
		// 	this.resources = navigationCfig["nav_config"][index].content;
		// 	localStorage.selectedKeys = index;
		// 	console.log(route);
		// 	this.$router.push(route);
		// },
		changeMenu(path, key) {
			this.selectedKeys = [key];
			console.log(path);
			this.$router.push(path);
		},
	},
};
</script>
